<template>
  <div class="rel">
    <!-- <v-btn class="absolute-close"  depressed dark  large  color="spiceRed"   @click="closeModal">
      <v-icon    >close</v-icon>
    </v-btn>-->
    <v-card class="transparent" flat>
      <v-card-text class="inner-content mt-2">
        <v-layout row wrap>
          <v-flex md7 xs12>
            <h1 class="title pb-3">
              Bill Pay /
              <span>Recharges</span>
            </h1>
            <h2>One stop solution for all your recharges and bill payments</h2>

            <p>
              Spice Money is offering bill payment services to customers at their doorstep through our network of agents.
              Now pay all your bills conveniently from one place. With our Bill Payments Service, save time – avoid waiting in long queues and travelling long distances to pay bills, pay all your bills in one place and next-door. Spice Money
              <strong>We make your life SIMPLE.</strong>
            </p>
            <p>
              <em>Pay all your bills in one place</em>
            </p>
          </v-flex>

          <v-flex md5 xs12 class="text-xs-center pl-5" v-if="this.$vuetify.breakpoint.lgAndUp">
            <img :src="require('@/assets/images/bills.jpg')" alt="spice money" width="100%">
          </v-flex>

          <v-flex xs12>
            <p>With Spice Money make Phone and DTH recharges in seconds. Over 30,800 million bills amounting to more than Rs. 6000 billion are generated each year in the top 20 cities in India. Bharat Bill Payment System (BBPS) is an RBI mandated system which offers integrated and interoperable bill payment services to customers across geographies with certainty, reliability and safety of transactions.
              <br>BBPS is a RBI mandated system which offers integrated and interoperable bill payment services to customers across geographies with certainty, reliability and safety of transactions.
            </p>
            <p>Spice Money Agents can subscribe to provide BBPS to the customers. Once an interested merchant registers as a Spice Money Agent, they will be eligible to provide financial services. Anyone can walk up to a Spice Money Agent to pay utility bills. The payment to the Spice Money Agent can then be made via cash, card or even through AePS. Every transaction is absolutely secure and safe.</p>

            <p>
              <strong>Spice Money as a Bharat Bill Payment Operating Unit (BBPOU) offers bill payment services to customers through its network of agents O2O (offline to online) for Electricity, Gas, Water, Mobile and DTH bills.</strong>
            </p>

            <ul class="icon-triggers">
              <li
                :class="electricity?'active':''"
                @click="payments=false; electricity=true; recharges=false"
              >
                <!-- <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Layer_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 512 512"
                  style="enable-background:new 0 0 512 512;"
                  xml:space="preserve"
                  width="100%"
                  height="100%"
                >
                  <g>
                    <g>
                      <path
                        d="M400.268,175.599c-1.399-3.004-4.412-4.932-7.731-4.932h-101.12l99.797-157.568c1.664-2.628,1.766-5.956,0.265-8.678    C389.977,1.69,387.109,0,384.003,0H247.47c-3.234,0-6.187,1.826-7.637,4.719l-128,256c-1.323,2.637-1.178,5.777,0.375,8.294    c1.562,2.517,4.301,4.053,7.262,4.053h87.748l-95.616,227.089c-1.63,3.883-0.179,8.388,3.413,10.59    c1.382,0.845,2.918,1.254,4.446,1.254c2.449,0,4.864-1.05,6.537-3.029l273.067-324.267    C401.206,182.161,401.667,178.611,400.268,175.599z"
                        fill="#FFFFFF"
                      ></path>
                    </g>
                  </g>
                </svg>-->
                Electricity
              </li>

              <li
                :class="recharges?'active':''"
                @click="payments=false; electricity=false; recharges=true"
              >
                <!-- <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 448 448"
                  style="enable-background:new 0 0 448 448;"
                  xml:space="preserve"
                  width="100%"
                  height="100%"
                >
                  <path
                    d="M304,64V32c0-17.6-14.4-32-32-32H80C62.4,0,48,14.4,48,32v384c0,17.6,14.4,32,32,32h192c17.6,0,32-14.4,32-32V288h-32v64    H80V32h192v32H304z M160,384h32v32h-32V384z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M368,96H192c-17.68,0-32,14.32-32,32v96c0,17.664,14.32,32,32,32h176c17.68,0,32-14.336,32-32v-96    C400,110.32,385.68,96,368,96z M224,224h-32v-16h32V224z M224,160h-32v-32h32V160z M272,224h-32v-16h32V224z M320,224h-32v-16h32    V224z M368,224h-32v-16h32V224z"
                    fill="#FFFFFF"
                  ></path>
                </svg>-->
                Recharges
              </li>
              <li
                :class="payments?'active':''"
                @click="payments=true; electricity=false; recharges=false"
              >
                <!-- <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  width="100%"
                  height="100%"
                  viewBox="0 0 63.745 63.745"
                  style="enable-background:new 0 0 63.745 63.745;"
                  xml:space="preserve"
                >
                  <path
                    d="M57.063,21.217v5.511l0.266,0.65l-0.266,0.108v9.717l3.665-1.495l0.804,1.967c0.354,0.87-0.045,1.859-0.89,2.205    L16.405,57.937c-0.837,0.342-1.831-0.104-2.178-0.952l-0.803-1.968l33.854-13.819H23.475l-13.45,5.49l-2.241-5.491h-2.25    L12.3,57.771c0.587,1.438,1.959,2.367,3.497,2.367c0.48,0,0.951-0.092,1.397-0.274L61.43,41.807c1.908-0.78,2.819-2.986,2.03-4.92    L57.063,21.217z"
                    fill="#FFFFFF"
                  ></path>
                  <polygon points="44.866,26.439 44.866,25.1 44.089,26.439   " fill="#FFFFFF"></polygon>
                  <polygon points="18.011,25.1 17.236,26.439 18.011,26.439   " fill="#FFFFFF"></polygon>
                  <path
                    d="M23.098,27.017c0.078-0.102,0.116-0.234,0.116-0.398c0-0.181-0.044-0.32-0.133-0.417    c-0.089-0.097-0.197-0.145-0.326-0.145c-0.104,0-0.197,0.032-0.276,0.095c-0.12,0.093-0.18,0.243-0.18,0.45    c0,0.167,0.045,0.304,0.135,0.409c0.09,0.106,0.205,0.159,0.343,0.159C22.913,27.17,23.02,27.118,23.098,27.017z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M8.95,34.536c0.116,0,0.225-0.033,0.324-0.102c0.099-0.066,0.15-0.189,0.153-0.37v-0.199    c-0.035,0.021-0.069,0.039-0.104,0.052c-0.034,0.013-0.083,0.024-0.144,0.036l-0.122,0.023c-0.115,0.019-0.197,0.044-0.248,0.073    c-0.084,0.049-0.127,0.125-0.127,0.228c0,0.092,0.026,0.156,0.077,0.197C8.812,34.516,8.876,34.536,8.95,34.536z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M30.07,27.166c0.139,0,0.25-0.042,0.329-0.126c0.079-0.084,0.119-0.204,0.119-0.356c0-0.158-0.041-0.279-0.121-0.361    c-0.082-0.083-0.19-0.123-0.327-0.123s-0.246,0.041-0.327,0.123c-0.081,0.082-0.121,0.202-0.121,0.361    c0,0.153,0.04,0.272,0.119,0.356S29.931,27.166,30.07,27.166z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M14.708,33.199c-0.138,0-0.244,0.038-0.32,0.116c-0.076,0.078-0.123,0.185-0.142,0.318h0.922    c-0.009-0.144-0.057-0.251-0.142-0.325C14.94,33.235,14.834,33.199,14.708,33.199z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M32.507,24.962c-0.104,0-0.193,0.029-0.268,0.087c-0.117,0.091-0.176,0.247-0.176,0.466c0,0.184,0.038,0.322,0.113,0.415    c0.075,0.092,0.19,0.138,0.345,0.138c0.086,0,0.164-0.024,0.238-0.073c0.139-0.088,0.208-0.243,0.208-0.46    c0-0.176-0.04-0.315-0.122-0.418C32.762,25.013,32.65,24.962,32.507,24.962z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M30.069,25.731c0.125,0,0.221-0.036,0.289-0.108c0.067-0.072,0.102-0.163,0.102-0.277c0-0.123-0.035-0.219-0.102-0.289    c-0.068-0.07-0.165-0.104-0.289-0.104c-0.123,0-0.22,0.034-0.289,0.104c-0.07,0.07-0.104,0.166-0.104,0.289    c0,0.112,0.034,0.205,0.104,0.277C29.849,25.696,29.946,25.731,30.069,25.731z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M21.257,33.977c-0.114,0.019-0.197,0.044-0.246,0.073c-0.084,0.049-0.127,0.125-0.127,0.228    c0,0.092,0.026,0.156,0.077,0.197c0.051,0.041,0.115,0.062,0.188,0.062c0.117,0,0.225-0.033,0.324-0.102    c0.099-0.067,0.15-0.189,0.153-0.37v-0.199c-0.034,0.021-0.068,0.039-0.104,0.052c-0.034,0.013-0.083,0.024-0.144,0.036    L21.257,33.977z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M30.247,33.977C30.132,33.995,30.05,34.021,30,34.05c-0.084,0.049-0.127,0.125-0.127,0.228    c0,0.092,0.026,0.156,0.077,0.197c0.051,0.041,0.115,0.062,0.189,0.062c0.116,0,0.225-0.033,0.324-0.102    c0.099-0.067,0.15-0.189,0.153-0.37v-0.199c-0.034,0.021-0.069,0.039-0.104,0.052c-0.034,0.013-0.083,0.024-0.144,0.036    L30.247,33.977z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M35.578,33.315c-0.077,0.078-0.123,0.185-0.143,0.318h0.923c-0.01-0.144-0.059-0.251-0.144-0.325    c-0.086-0.073-0.191-0.109-0.317-0.109C35.759,33.199,35.653,33.237,35.578,33.315z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M49.631,27.17c0.136,0,0.242-0.052,0.32-0.153c0.079-0.102,0.117-0.234,0.117-0.398c0-0.181-0.045-0.32-0.134-0.417    c-0.088-0.097-0.196-0.145-0.326-0.145c-0.104,0-0.197,0.032-0.275,0.095c-0.12,0.093-0.18,0.243-0.18,0.45    c0,0.167,0.044,0.304,0.135,0.409C49.378,27.117,49.494,27.17,49.631,27.17z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M5.309,26.881c0.058,0.189,0.179,0.285,0.36,0.285c0.181,0,0.3-0.095,0.357-0.285c0.049-0.162,0.072-0.4,0.08-0.686    c0.001-0.047,0.006-0.083,0.006-0.133c0-0.374-0.028-0.652-0.084-0.832c-0.056-0.18-0.175-0.27-0.357-0.27    c-0.182,0-0.301,0.089-0.36,0.27c-0.06,0.18-0.088,0.458-0.088,0.832c0,0.184,0.008,0.345,0.024,0.484    C5.258,26.677,5.279,26.79,5.309,26.881z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M2.176,38.916c0.484,0.229,1.02,0.368,1.589,0.368h0.987h2.25h21.16h23.803h0.028c1.016,0,1.935-0.413,2.614-1.078    c0.706-0.694,1.151-1.661,1.151-2.735V28.02v-4.484v-5.513V7.421c0-1.074-0.445-2.042-1.151-2.735    c-0.68-0.665-1.599-1.079-2.614-1.079H3.766C1.689,3.607,0,5.319,0,7.421v28.05C0,36.995,0.895,38.306,2.176,38.916z     M4.596,26.062c0-0.513,0.08-0.91,0.239-1.188c0.159-0.279,0.436-0.418,0.833-0.418c0.396,0,0.674,0.14,0.833,0.418    c0.145,0.254,0.216,0.617,0.228,1.065c0.001,0.043,0.011,0.076,0.011,0.122c0,0.513-0.08,0.908-0.239,1.185    s-0.437,0.416-0.833,0.416c-0.396,0-0.674-0.138-0.833-0.416c-0.074-0.128-0.126-0.288-0.166-0.466    C4.623,26.573,4.596,26.337,4.596,26.062z M33.738,13.61c0-2.834,2.308-5.141,5.142-5.141c1.117,0,2.146,0.369,2.99,0.977    c0.877-0.701,1.974-1.138,3.181-1.138c1.035,0,1.996,0.313,2.803,0.845c0.667,0.438,1.209,1.033,1.61,1.724    c0.438,0.755,0.708,1.62,0.708,2.554c0,2.824-2.298,5.122-5.121,5.122c-1.107,0-2.125-0.361-2.963-0.96    c-0.883,0.712-1.988,1.158-3.208,1.158c-1.66,0-3.121-0.803-4.061-2.026c-0.426-0.551-0.739-1.183-0.912-1.878    C33.806,14.449,33.738,14.039,33.738,13.61z M32.77,33.376c-0.046-0.1-0.134-0.148-0.266-0.148c-0.154,0-0.256,0.049-0.309,0.148    c-0.029,0.056-0.042,0.141-0.042,0.252v1.233h-0.544v-2.046h0.521v0.299c0.066-0.106,0.129-0.182,0.188-0.227    c0.104-0.08,0.238-0.121,0.404-0.121c0.155,0,0.283,0.033,0.38,0.103c0.076,0.063,0.137,0.146,0.176,0.247    c0.071-0.121,0.157-0.208,0.262-0.266c0.111-0.057,0.233-0.084,0.369-0.084c0.09,0,0.18,0.018,0.267,0.052    c0.088,0.036,0.167,0.097,0.238,0.185c0.057,0.072,0.098,0.159,0.116,0.264c0.013,0.068,0.019,0.169,0.019,0.303l-0.004,1.292    h-0.548v-1.306c0-0.077-0.014-0.141-0.039-0.191c-0.047-0.094-0.134-0.143-0.262-0.143c-0.149,0-0.251,0.062-0.308,0.185    c-0.028,0.064-0.043,0.144-0.043,0.234v1.221h-0.54v-1.221C32.807,33.52,32.795,33.431,32.77,33.376z M32.811,26.462    c-0.114,0.068-0.255,0.103-0.422,0.103c-0.247,0-0.466-0.085-0.658-0.256c-0.192-0.171-0.288-0.417-0.288-0.738    c0-0.333,0.096-0.604,0.289-0.81c0.192-0.207,0.441-0.31,0.749-0.31c0.474,0,0.798,0.209,0.974,0.628    c0.101,0.237,0.149,0.55,0.149,0.937c0,0.376-0.047,0.689-0.144,0.94c-0.184,0.479-0.519,0.718-1.007,0.718    c-0.234,0-0.443-0.069-0.628-0.207c-0.186-0.139-0.293-0.34-0.32-0.603h0.608c0.015,0.091,0.054,0.165,0.116,0.223    c0.062,0.058,0.146,0.085,0.252,0.085c0.2,0,0.342-0.111,0.423-0.335c0.045-0.123,0.072-0.301,0.083-0.538    C32.934,26.372,32.875,26.425,32.811,26.462z M29.158,25.606c-0.044-0.117-0.067-0.226-0.067-0.327    c0-0.227,0.085-0.419,0.255-0.579c0.17-0.159,0.411-0.238,0.722-0.238c0.31,0,0.551,0.079,0.722,0.238s0.255,0.352,0.255,0.579    c0,0.101-0.023,0.21-0.068,0.327c-0.044,0.116-0.143,0.217-0.293,0.303c0.153,0.085,0.269,0.199,0.347,0.34    c0.077,0.142,0.117,0.299,0.117,0.474c0,0.262-0.097,0.485-0.291,0.668c-0.193,0.183-0.464,0.275-0.812,0.275    c-0.348,0-0.611-0.092-0.79-0.275s-0.269-0.406-0.269-0.668c0-0.174,0.04-0.332,0.119-0.474c0.079-0.141,0.193-0.248,0.345-0.319    C29.301,25.831,29.203,25.723,29.158,25.606z M30.53,33.241c-0.06-0.032-0.146-0.049-0.261-0.049c-0.128,0-0.22,0.033-0.272,0.095    c-0.039,0.046-0.063,0.109-0.076,0.188h-0.518c0.012-0.179,0.062-0.326,0.151-0.441c0.142-0.18,0.386-0.271,0.732-0.271    c0.225,0,0.425,0.045,0.601,0.133c0.175,0.09,0.262,0.258,0.262,0.505v0.94c0,0.064,0.001,0.144,0.004,0.237    c0.004,0.069,0.015,0.117,0.032,0.143c0.018,0.024,0.044,0.046,0.08,0.063v0.078h-0.583c-0.017-0.042-0.027-0.08-0.033-0.117    c-0.006-0.036-0.012-0.077-0.015-0.124c-0.075,0.081-0.16,0.149-0.257,0.205c-0.115,0.067-0.247,0.101-0.394,0.101    c-0.187,0-0.341-0.054-0.462-0.158c-0.122-0.106-0.183-0.256-0.183-0.45c0-0.252,0.098-0.434,0.294-0.547    c0.107-0.062,0.266-0.104,0.474-0.131l0.183-0.022c0.1-0.014,0.171-0.028,0.215-0.047c0.077-0.032,0.115-0.083,0.115-0.152    C30.618,33.331,30.588,33.272,30.53,33.241z M28.386,33.366c-0.052-0.105-0.152-0.158-0.297-0.158    c-0.181,0-0.304,0.077-0.372,0.231c-0.035,0.081-0.052,0.185-0.052,0.312v1.109h-0.537v-2.046h0.519v0.299    c0.068-0.104,0.133-0.182,0.194-0.227c0.109-0.083,0.25-0.124,0.418-0.124c0.211,0,0.383,0.055,0.517,0.167    c0.135,0.11,0.202,0.295,0.202,0.551v1.381h-0.549v-1.246C28.429,33.507,28.416,33.424,28.386,33.366z M25.409,34.452    c0.022,0.021,0.086,0.03,0.196,0.03c0.017,0,0.034,0,0.053,0c0.018-0.002,0.036-0.002,0.054-0.004v0.401l-0.254,0.009    c-0.253,0.008-0.426-0.036-0.519-0.131c-0.06-0.062-0.091-0.157-0.091-0.285v-1.262h-0.286v-0.38h0.286v-0.573h0.531v0.573h0.333    v0.38h-0.333v1.084C25.377,34.379,25.387,34.431,25.409,34.452z M25.514,26.193c-0.087,0.192-0.166,0.429-0.237,0.707    c-0.07,0.278-0.105,0.508-0.105,0.687h-0.634c0.019-0.558,0.202-1.136,0.549-1.739c0.225-0.373,0.413-0.633,0.564-0.78h-1.549    l0.008-0.549h2.195v0.479c-0.092,0.089-0.219,0.25-0.382,0.481C25.76,25.708,25.623,25.946,25.514,26.193z M16.781,26.917v-0.533    l1.143-1.886h0.687v1.942h0.351v0.478H18.61v0.669h-0.598v-0.669L16.781,26.917L16.781,26.917z M18.179,32.089h0.579v2.273h1.385    v0.499h-1.964V32.089z M19.54,27.429c-0.189-0.159-0.296-0.384-0.317-0.675h0.608c0.024,0.133,0.071,0.235,0.139,0.307    s0.167,0.108,0.298,0.108c0.151,0,0.267-0.054,0.346-0.16c0.08-0.105,0.119-0.24,0.119-0.401c0-0.158-0.038-0.293-0.111-0.402    c-0.074-0.109-0.19-0.164-0.347-0.164c-0.074,0-0.139,0.009-0.193,0.028c-0.096,0.034-0.168,0.098-0.217,0.19l-0.548-0.026    l0.218-1.717h1.71v0.519h-1.27l-0.111,0.679c0.095-0.062,0.167-0.103,0.221-0.122c0.088-0.033,0.196-0.049,0.323-0.049    c0.257,0,0.481,0.086,0.672,0.259c0.191,0.173,0.286,0.423,0.286,0.754c0,0.287-0.093,0.543-0.276,0.77    c-0.184,0.226-0.459,0.338-0.827,0.338C19.972,27.667,19.729,27.588,19.54,27.429z M21.541,33.241    c-0.06-0.032-0.146-0.049-0.26-0.049c-0.128,0-0.22,0.033-0.273,0.095c-0.039,0.046-0.064,0.109-0.076,0.188h-0.517    c0.012-0.179,0.062-0.326,0.151-0.441c0.142-0.18,0.387-0.271,0.732-0.271c0.225,0,0.425,0.045,0.601,0.133    c0.175,0.09,0.263,0.258,0.263,0.505v0.94c0,0.064,0.001,0.144,0.004,0.237c0.004,0.069,0.015,0.117,0.032,0.143    c0.018,0.024,0.044,0.046,0.08,0.063v0.078h-0.583c-0.016-0.042-0.027-0.08-0.034-0.117c-0.006-0.036-0.011-0.077-0.014-0.124    c-0.074,0.081-0.161,0.149-0.257,0.205c-0.116,0.067-0.247,0.101-0.394,0.101c-0.187,0-0.341-0.054-0.463-0.158    c-0.122-0.106-0.182-0.256-0.182-0.45c0-0.252,0.098-0.434,0.294-0.547c0.107-0.062,0.266-0.104,0.474-0.131l0.184-0.022    c0.1-0.014,0.171-0.028,0.214-0.047c0.075-0.037,0.114-0.088,0.114-0.155C21.629,33.331,21.6,33.272,21.541,33.241z     M21.902,27.176c-0.145-0.256-0.217-0.585-0.217-0.991c0-0.237,0.01-0.43,0.03-0.579c0.036-0.265,0.105-0.485,0.208-0.661    c0.088-0.15,0.205-0.271,0.348-0.362c0.143-0.092,0.315-0.138,0.515-0.138c0.289,0,0.519,0.074,0.691,0.222    s0.268,0.345,0.29,0.591H23.16c0-0.05-0.019-0.105-0.059-0.165c-0.065-0.097-0.165-0.146-0.298-0.146    c-0.199,0-0.341,0.111-0.424,0.334c-0.046,0.123-0.077,0.304-0.095,0.545c0.076-0.09,0.164-0.156,0.264-0.197    c0.1-0.042,0.214-0.062,0.343-0.062c0.276,0,0.502,0.094,0.678,0.281c0.176,0.188,0.265,0.427,0.265,0.718    s-0.086,0.546-0.259,0.768c-0.173,0.222-0.442,0.333-0.807,0.333C22.377,27.667,22.088,27.504,21.902,27.176z M23.76,34.191    c-0.05-0.031-0.237-0.085-0.562-0.161c-0.232-0.059-0.396-0.131-0.491-0.217c-0.095-0.086-0.143-0.209-0.143-0.368    c0-0.19,0.074-0.353,0.223-0.489c0.149-0.136,0.359-0.205,0.628-0.205c0.256,0,0.465,0.051,0.626,0.154    c0.162,0.103,0.254,0.277,0.278,0.528h-0.536c-0.007-0.067-0.027-0.123-0.058-0.163c-0.06-0.072-0.16-0.108-0.301-0.108    c-0.117,0-0.2,0.019-0.25,0.054c-0.05,0.037-0.075,0.08-0.075,0.129c0,0.062,0.027,0.106,0.079,0.133    c0.053,0.029,0.239,0.078,0.559,0.148c0.214,0.051,0.374,0.126,0.48,0.229c0.105,0.103,0.159,0.23,0.159,0.385    c0,0.203-0.077,0.368-0.228,0.497c-0.151,0.128-0.386,0.192-0.702,0.192c-0.323,0-0.562-0.067-0.715-0.204    c-0.154-0.136-0.231-0.309-0.231-0.52h0.544c0.012,0.095,0.036,0.162,0.074,0.202c0.066,0.073,0.19,0.108,0.371,0.108    c0.106,0,0.19-0.016,0.252-0.047c0.062-0.03,0.094-0.078,0.094-0.141C23.835,34.27,23.811,34.223,23.76,34.191z M14.446,34.42    c0.083,0.051,0.18,0.077,0.296,0.077c0.122,0,0.221-0.031,0.298-0.094c0.042-0.033,0.078-0.081,0.11-0.143h0.547    c-0.015,0.122-0.081,0.245-0.2,0.371c-0.183,0.199-0.44,0.299-0.771,0.299c-0.273,0-0.514-0.084-0.722-0.252    c-0.208-0.168-0.313-0.441-0.313-0.82c0-0.355,0.094-0.627,0.283-0.817c0.188-0.188,0.432-0.283,0.733-0.283    c0.178,0,0.339,0.032,0.482,0.096c0.143,0.062,0.261,0.164,0.354,0.303c0.084,0.122,0.138,0.264,0.164,0.423    c0.015,0.096,0.021,0.231,0.018,0.408h-1.493C14.239,34.191,14.312,34.336,14.446,34.42z M13.951,25.311    c0,0.184-0.054,0.338-0.163,0.464c-0.068,0.079-0.14,0.132-0.214,0.161c0.056,0,0.135,0.047,0.239,0.144    c0.156,0.145,0.233,0.341,0.233,0.592c0,0.262-0.091,0.494-0.273,0.694c-0.182,0.199-0.452,0.298-0.808,0.298    c-0.439,0-0.745-0.144-0.917-0.431c-0.09-0.153-0.14-0.354-0.15-0.6h0.6c0,0.124,0.02,0.227,0.059,0.308    c0.074,0.15,0.209,0.225,0.405,0.225c0.119,0,0.224-0.041,0.313-0.123c0.089-0.083,0.133-0.2,0.133-0.355    c0-0.205-0.083-0.341-0.248-0.409c-0.094-0.039-0.243-0.059-0.445-0.059v-0.438c0.198-0.003,0.337-0.022,0.415-0.059    c0.092-0.041,0.141-0.121,0.171-0.219c0.014-0.046,0.033-0.087,0.033-0.146c0-0.118-0.035-0.214-0.103-0.289    c-0.07-0.074-0.167-0.112-0.292-0.112c-0.144,0-0.25,0.046-0.318,0.138c-0.068,0.091-0.101,0.213-0.097,0.367h-0.57    c0.005-0.154,0.033-0.301,0.08-0.439c0.05-0.122,0.128-0.233,0.235-0.337c0.08-0.073,0.175-0.128,0.284-0.167    c0.11-0.039,0.245-0.058,0.405-0.058c0.297,0,0.537,0.077,0.719,0.23c0.166,0.14,0.245,0.328,0.261,0.554    C13.941,25.27,13.951,25.287,13.951,25.311z M12.77,33.364c-0.048-0.094-0.135-0.143-0.264-0.143c-0.148,0-0.25,0.062-0.306,0.185    c-0.029,0.064-0.044,0.144-0.044,0.234v1.221h-0.539v-1.221c0-0.122-0.013-0.211-0.038-0.265c-0.045-0.1-0.133-0.148-0.265-0.148    c-0.153,0-0.255,0.049-0.309,0.148c-0.029,0.056-0.042,0.141-0.042,0.252v1.233h-0.544v-2.046h0.521v0.299    c0.066-0.106,0.129-0.182,0.188-0.227c0.104-0.08,0.239-0.121,0.404-0.121c0.156,0,0.284,0.033,0.38,0.103    c0.078,0.063,0.137,0.146,0.176,0.247c0.071-0.121,0.158-0.208,0.261-0.266c0.11-0.057,0.233-0.084,0.369-0.084    c0.091,0,0.18,0.018,0.267,0.052c0.088,0.036,0.167,0.097,0.239,0.185c0.057,0.072,0.097,0.159,0.116,0.264    c0.013,0.068,0.019,0.169,0.019,0.303l-0.004,1.292h-0.549v-1.306C12.809,33.479,12.795,33.415,12.77,33.364z M37.723,25.11    c-0.072-0.087-0.178-0.131-0.312-0.131c-0.186,0-0.312,0.07-0.379,0.208c-0.038,0.081-0.062,0.208-0.069,0.381h-0.594    c0.01-0.264,0.059-0.478,0.145-0.641c0.163-0.311,0.452-0.465,0.868-0.465c0.329,0,0.591,0.09,0.786,0.273    c0.194,0.182,0.291,0.423,0.291,0.724c0,0.23-0.069,0.435-0.206,0.614c-0.092,0.119-0.239,0.251-0.445,0.397l-0.244,0.174    c-0.153,0.108-0.259,0.188-0.315,0.235c-0.056,0.049-0.104,0.105-0.143,0.17h1.357v0.539h-2.128    c0.004-0.223,0.053-0.427,0.142-0.611c0.088-0.208,0.293-0.427,0.619-0.659c0.28-0.201,0.464-0.346,0.547-0.434    c0.126-0.135,0.19-0.284,0.19-0.445C37.833,25.306,37.795,25.197,37.723,25.11z M36.378,32.854    c0.143,0.062,0.263,0.164,0.354,0.303c0.085,0.122,0.139,0.264,0.165,0.423c0.014,0.096,0.021,0.231,0.016,0.408H35.42    c0.008,0.204,0.08,0.35,0.215,0.433c0.082,0.051,0.18,0.077,0.296,0.077c0.122,0,0.221-0.031,0.298-0.094    c0.042-0.033,0.078-0.081,0.111-0.143h0.546c-0.015,0.122-0.08,0.245-0.198,0.371c-0.184,0.199-0.441,0.299-0.771,0.299    c-0.272,0-0.514-0.084-0.722-0.252s-0.312-0.441-0.312-0.82c0-0.355,0.094-0.627,0.282-0.817c0.188-0.188,0.433-0.283,0.734-0.283    C36.076,32.758,36.237,32.79,36.378,32.854z M35.417,27.586H34.79v-2.144h-0.73v-0.416c0.193-0.008,0.328-0.022,0.404-0.039    c0.123-0.027,0.223-0.081,0.299-0.162c0.054-0.056,0.093-0.13,0.12-0.223c0.016-0.056,0.023-0.097,0.023-0.124h0.511V27.586z     M42.458,26.278c-0.094-0.039-0.243-0.059-0.445-0.059v-0.438c0.197-0.003,0.337-0.022,0.415-0.059    c0.136-0.061,0.204-0.181,0.204-0.365c0-0.118-0.035-0.214-0.104-0.289c-0.069-0.074-0.167-0.112-0.291-0.112    c-0.145,0-0.25,0.046-0.318,0.138c-0.067,0.091-0.101,0.213-0.097,0.367h-0.569c0.004-0.154,0.032-0.301,0.079-0.439    c0.049-0.122,0.129-0.233,0.235-0.337c0.08-0.073,0.175-0.128,0.284-0.167c0.11-0.039,0.245-0.058,0.404-0.058    c0.297,0,0.537,0.077,0.721,0.23c0.181,0.153,0.272,0.359,0.272,0.619c0,0.183-0.056,0.338-0.163,0.463    c-0.069,0.08-0.141,0.133-0.215,0.161c0.057,0,0.136,0.048,0.241,0.144c0.156,0.145,0.233,0.342,0.233,0.592    c0,0.262-0.091,0.493-0.273,0.693c-0.182,0.199-0.452,0.299-0.809,0.299c-0.439,0-0.746-0.144-0.916-0.432    c-0.091-0.152-0.14-0.353-0.149-0.6h0.599c0,0.125,0.02,0.227,0.061,0.309c0.073,0.15,0.209,0.225,0.403,0.225    c0.119,0,0.224-0.041,0.313-0.123c0.089-0.083,0.134-0.2,0.134-0.355C42.706,26.483,42.622,26.347,42.458,26.278z M45.816,26.439    v0.478h-0.353v0.669h-0.598v-0.669h-1.229v-0.534l1.142-1.886h0.688v1.942H45.816z M47.477,26.206    c-0.073-0.109-0.189-0.164-0.347-0.164c-0.074,0-0.139,0.009-0.192,0.028c-0.096,0.034-0.169,0.098-0.218,0.19l-0.547-0.026    l0.218-1.717h1.711v0.519h-1.271l-0.111,0.679c0.095-0.062,0.167-0.103,0.22-0.122c0.09-0.033,0.196-0.049,0.323-0.049    c0.258,0,0.481,0.086,0.672,0.259c0.191,0.173,0.286,0.423,0.286,0.754c0,0.287-0.092,0.543-0.275,0.77s-0.459,0.338-0.827,0.338    c-0.296,0-0.539-0.079-0.728-0.237c-0.189-0.159-0.297-0.383-0.318-0.675h0.608c0.024,0.133,0.071,0.235,0.14,0.307    s0.169,0.108,0.299,0.108c0.152,0,0.267-0.054,0.347-0.16c0.078-0.106,0.118-0.241,0.118-0.402    C47.589,26.45,47.55,26.315,47.477,26.206z M50.623,25.26h-0.608c0-0.05-0.02-0.105-0.059-0.165    c-0.065-0.097-0.165-0.146-0.298-0.146c-0.199,0-0.342,0.111-0.425,0.334c-0.045,0.123-0.077,0.304-0.094,0.545    c0.075-0.09,0.163-0.156,0.263-0.197c0.1-0.042,0.216-0.063,0.344-0.063c0.274,0,0.501,0.094,0.678,0.282    c0.176,0.188,0.265,0.427,0.265,0.717c0,0.291-0.087,0.546-0.26,0.768c-0.173,0.222-0.441,0.333-0.807,0.333    c-0.391,0-0.68-0.164-0.865-0.491c-0.146-0.256-0.217-0.585-0.217-0.991c0-0.237,0.011-0.43,0.03-0.579    c0.035-0.265,0.105-0.484,0.208-0.661c0.089-0.15,0.205-0.271,0.349-0.362c0.143-0.092,0.315-0.138,0.516-0.138    c0.288,0,0.519,0.074,0.69,0.222C50.504,24.817,50.6,25.014,50.623,25.26z M10.527,24.462c0.33,0,0.591,0.09,0.786,0.273    c0.195,0.182,0.292,0.423,0.292,0.724c0,0.23-0.068,0.435-0.206,0.614c-0.089,0.117-0.235,0.247-0.437,0.39    c-0.003,0.002-0.005,0.004-0.008,0.006l-0.245,0.174c-0.153,0.108-0.258,0.188-0.315,0.235c-0.056,0.049-0.104,0.105-0.143,0.17    h1.357v0.539H9.479c0.005-0.208,0.051-0.397,0.129-0.572c0.005-0.013,0.008-0.027,0.014-0.04c0.087-0.208,0.292-0.427,0.618-0.659    c0.281-0.201,0.464-0.346,0.546-0.434c0.127-0.135,0.191-0.284,0.191-0.445c0-0.131-0.037-0.241-0.109-0.328    s-0.177-0.131-0.312-0.131c-0.186,0-0.312,0.07-0.379,0.208c-0.039,0.081-0.062,0.208-0.068,0.381H9.514    c0.01-0.264,0.058-0.478,0.144-0.641c0.071-0.135,0.177-0.228,0.296-0.304c0.056-0.035,0.123-0.054,0.188-0.077    C10.259,24.506,10.375,24.462,10.527,24.462z M6.079,34.861H5.54v-2.772h0.607l1.1,1.933v-1.933h0.54v2.772H7.208l-1.127-1.967    v1.967H6.079z M7.937,27.586v-2.139v-0.005H7.205v-0.416c0.193-0.008,0.327-0.022,0.404-0.039    c0.123-0.027,0.223-0.081,0.299-0.162c0.053-0.056,0.092-0.13,0.119-0.223c0.016-0.056,0.024-0.097,0.024-0.124h0.511v0.715v2.25    v0.144H8.209L7.937,27.586L7.937,27.586z M5.928,17.873v-1.978h1.986v2.023H5.933C5.933,17.902,5.928,17.888,5.928,17.873z     M7.914,20.517c-0.792-0.237-1.44-0.807-1.762-1.558h1.762V20.517z M8.955,18.959h1.717v1.685H8.955V18.959z M11.713,18.959h1.763    c-0.322,0.751-0.971,1.321-1.763,1.558V18.959z M13.699,17.873c0,0.016-0.004,0.029-0.004,0.045h-1.98v-2.023H13.7L13.699,17.873    L13.699,17.873z M11.193,14.853L11.193,14.853l-0.521,0.001v3.063H8.955v-5.045h1.973c1.251,0,2.299,0.839,2.642,1.98H11.193z     M7.914,14.853H6.057C6.325,13.962,7.022,13.267,7.914,13V14.853z M8.441,33.769c0.107-0.061,0.266-0.105,0.474-0.131l0.184-0.023    c0.1-0.013,0.17-0.027,0.214-0.047c0.077-0.033,0.116-0.084,0.116-0.151c0-0.085-0.029-0.142-0.088-0.175    c-0.06-0.032-0.146-0.049-0.26-0.049c-0.128,0-0.22,0.033-0.273,0.095c-0.039,0.046-0.063,0.109-0.076,0.188H8.215    c0.011-0.179,0.062-0.326,0.151-0.441c0.142-0.18,0.387-0.271,0.732-0.271c0.225,0,0.425,0.045,0.601,0.133    c0.175,0.09,0.263,0.258,0.263,0.505v0.94c0,0.064,0.001,0.144,0.004,0.237c0.004,0.069,0.014,0.118,0.032,0.143    c0.018,0.024,0.043,0.046,0.079,0.063v0.078H9.494c-0.017-0.042-0.027-0.08-0.033-0.117c-0.006-0.036-0.011-0.077-0.015-0.124    c-0.074,0.081-0.161,0.149-0.257,0.205c-0.116,0.067-0.247,0.101-0.394,0.101c-0.187,0-0.341-0.054-0.463-0.158    c-0.122-0.106-0.182-0.256-0.182-0.45C8.148,34.064,8.246,33.881,8.441,33.769z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M35.824,16.314c0.75,0.849,1.836,1.395,3.056,1.395c0.873,0,1.679-0.279,2.345-0.748h0.132h0.685h0.092h0.61h0.203    c0.013-0.01,0.021-0.024,0.035-0.034c0.278-0.223,0.533-0.473,0.751-0.756h-0.425H42.72h-0.669h-0.005h-0.675h-0.637    c-0.121-0.195-0.232-0.399-0.329-0.611h0.589h0.593h0.875h0.592h0.577h0.495c0.134-0.251,0.244-0.515,0.329-0.791h-0.578h-0.543    h-0.543h-1.576H40.67h-0.542c-0.017-0.063-0.043-0.124-0.057-0.188c-0.039-0.162-0.055-0.329-0.075-0.495h0.521h0.521h0.244h1.65    h0.521h0.521h0.638c0.028-0.204,0.062-0.408,0.062-0.62c0-0.058-0.015-0.112-0.019-0.171H43.99h-0.521H43.22h-0.272h-1.965h-0.521    h-0.521c0.007-0.226,0.033-0.447,0.068-0.664h0.521h0.521h1.795h0.545h0.529h0.666c-0.053-0.274-0.133-0.538-0.232-0.791h-0.667    h-0.542H42.56h-1.268h-0.021h-0.524h-0.542c0.079-0.237,0.169-0.463,0.279-0.683h0.588h0.592h0.479h0.638h0.165h0.422h0.641    c-0.073-0.119-0.17-0.219-0.25-0.331c-0.114-0.156-0.216-0.322-0.351-0.461h-0.574h-0.449h-0.22h-0.522h-0.286h-0.383    c0.047-0.062,0.1-0.12,0.148-0.18c-0.645-0.422-1.413-0.674-2.24-0.674c-2.261,0-4.1,1.839-4.1,4.099    c0,0.29,0.032,0.571,0.09,0.843C35.018,15.161,35.361,15.792,35.824,16.314z"
                    fill="#FFFFFF"
                  ></path>
                </svg>-->
                Payments
              </li>
            </ul>
          </v-flex>
        </v-layout>
        <transition name="fadeY" mode="out-in">
          <v-layout row wrap py-5 v-if="electricity">
            <v-flex xs12>
              <h2>Electricity Bill Payments</h2>
            </v-flex>
            <v-flex md12 xs12>
              <h3 class="pb-3">Pay your electricity bills on-time every-time</h3>
              <p>Electricity is one of the most essential and important commodities of our modern life, at home and at work. Electricity is used in every sphere whether it’s electric appliances at home or computers and huge machines in offices and industries.</p>
              <p>It is essential that you pay your electricity bills on-time every-time and Spice Money helps you do just that. Enjoy uninterrupted supply of electricity and avoid late payment charges with Spice Money.</p>
              <p>Physically paying electricity bills can be a cumbersome job, Spice Money Agents can help you pay your bill easily on-time every-time. Every transaction is absolutely secure and safe.</p>
            </v-flex>
          </v-layout>
        </transition>
        <transition name="fadeY" mode="out-in">
          <v-layout row wrap py-5 v-if="recharges">
            <v-flex xs12>
              <h2>Mobile / DTH Recharges</h2>
            </v-flex>
            <v-flex md12 xs12>
              <p>Mobile Recharge is a single platform where transaction can be done through a single SIM for multiple operators and allows the retailer to do an instant mobile and DTH recharge through a simple web interface.</p>
              <p>
                <em>Key Features</em>
              </p>
              <ul class="standard-listing">
                <li>
                  <strong>DTH recharge:</strong> For all major DTH Service providers in India such as, Tata Sky, DISH TV, Videocon, Sun TV and Reliance Big TV.
                </li>
                <li>
                  <strong>Single SIM and Wallet:</strong> Allows recharge for any operator through a single SIM and wallet interface. We provide all operator recharges, available across all circles in India.
                </li>
                <li>
                  <strong>Recharge any amount:</strong> Allows recharge starting as minimal as Rs. 10/- to any desired amount.
                </li>
                <li>
                  <strong>Instant confirmation and Fund Transfer:</strong> Instant confirmation on MT and Fund transfer via SMS.
                </li>
                <li>
                  <strong>Mobile App recharge:</strong> Allows recharge anytime/anywhere.
                </li>
              </ul>
            </v-flex>
          </v-layout>
        </transition>
        <transition name="fadeY" mode="out-in">
          <v-layout row wrap py-5 v-if="payments">
            <v-flex xs12>
              <h2>Digital Payments</h2>
            </v-flex>
            <v-flex md12 xs12>
              <h3 class="pb-3">Providing digital payment solutions</h3>
              <p>Spice Money provides digital payment solutions to the underserved section of the society through its strong Agent Network using Semi-closed Wallet – Spice Money enabling Direct Money Transfer (DMT).</p>
              <p>It is an assisted retailer model that allows cash transfer from retail locations and instant fund transfer to bank accounts across India. The service is available 24X7.</p>
            </v-flex>
          </v-layout>
        </transition>
        <!-- <div class="earn-now">
      <v-layout row wrap align-center>
        <v-flex xs12 md8>
           Earn ₹ 20,000 to ₹ 50,000 every month
        </v-flex>
        <v-flex xs12 md4 text-lg-right>
         
<a href="https://lead.spicemoney.com/LeadGeneration/login?mode=web1" class="join-now" target="_blank">Join Now</a>
        </v-flex>
        
      </v-layout>
     

 
        </div>-->
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>
.v-toolbar__title {
  color: #2a3997 !important;
}
.title {
  text-transform: uppercase;
  font-size: 64px !important;
  color: #000;
  font-weight: 100;
}
.title span {
  font-weight: 900;
}
h2 {
  font-size: 30px;
  padding-bottom: 15px;
}
p {
  font-size: 15px;
  line-height: 20px;
  margin-bottom: 10px;
  color: #333;
}

.content-img {
  -webkit-box-shadow: 0 5px 20px 0 rgba(54, 57, 73, 0.09);
  box-shadow: 0 5px 20px 0 rgba(54, 57, 73, 0.09);
}
.logo-inner {
  align-items: center;
}
.nav-listing {
  list-style: none;
  display: flex;
  flex-direction: row;
}
.nav-listing li {
  margin-left: 10px;
}
.nav-listing li a {
  text-decoration: none;
  padding: 10px 15px;
  transition: all ease-in-out 0.2s;
  color: #475055;
  font-size: 16px;
}
.nav-listing li a:hover,
.nav-listing li a.active {
  color: #4385f3;
}
.icon-triggers {
  list-style: none;
  margin: 30px 0 0 0;
  padding: 12px 0 0px 50px;
  background: #293896;
}
.icon-triggers li {
  position: relative;
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  min-width: 150px;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 5px;
  opacity: 0.7;
  border-bottom: solid 3px tranparent;
  margin-right: 15px;
}
.icon-triggers li.active,
.icon-triggers li:hover {
  opacity: 1;
  border-bottom: solid 3px orange;
}
/* .inner-content {
}

.icon-triggers {
  list-style: none;
  margin: 0;
  padding: 30px 0 0 0;
}
.icon-triggers li {
  position: relative;
  cursor: pointer;
  display: inline-block;
  color: #ff7a00;
  border: 3px solid #ff7a00;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  line-height: 0;
  padding: 1.9em;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  width: 120px;
  height: 120px;
  margin-right: 8%;
  animation: categoryTriggerPulse 3s infinite;
}

.icon-triggers li:before,
.icon-triggers li:after {
  content: "";
  display: block;
  position: absolute;
  width: 120%;
  height: 120%;
  top: -10%;
  left: -10%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  opacity: 0;
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.icon-triggers li:before {
  border: 2px solid #ff7a00;
}

.icon-triggers li.active,
.icon-triggers li:hover {
  background-color: rgb(255, 122, 0);
  color: #fff;

  animation: none;
}
.icon-triggers path {
  transition: all ease-in-out 0.6s;
}
.icon-triggers li path,
.icon-triggers li path {
  fill: rgb(255, 122, 0);
}

.icon-triggers li.active path,
.icon-triggers li:hover path {
  fill: #fff;
}

.icon-triggers li.active:hover {
  cursor: default;
}

.icon-triggers li:not(.active):hover:before {
  border-top-color: #ff7a00;
  border-right-color: #ff7a00;
  border-bottom-color: #ff7a00;
  -webkit-transition: border-top-color 0.15s linear,
    border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
  transition: border-top-color 0.15s linear,
    border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
}

.icon-triggers li:not(.active):hover:after {
  border-top: 3px solid #ff7a00;
  border-left-width: 2px;
  border-right-width: 2px;
  -webkit-transform: rotate(540deg);
  -ms-transform: rotate(540deg);
  transform: rotate(540deg);
  -webkit-transition: border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
  transition: border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
  transition: transform 0.4s linear 0s, border-left-width 0s linear 0.35s;
  transition: transform 0.4s linear 0s, border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
}

.icon-triggers li:hover:after {
  opacity: 1;
}

@-webkit-keyframes categoryTriggerPulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgb(255, 122, 0, 0.8);
  }
  50% {
    -webkit-box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
  }
}

@keyframes categoryTriggerPulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0.8);
    box-shadow: 0 0 0 0 rgba(255, 122, 0, 0.8);
  }
  50% {
    -moz-box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
    box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
    box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
  }
} */

.standard-listing {
  color: #343434;
}
.standard-listing li {
  float: left;
  width: 100%;
}
@media only screen and (max-width: 768px) {
  .inner-content {
    padding: 25px;
  }
  .title {
    font-size: 18px !important;
  }
}

.earn-now {
  position: relative;
  padding: 25px 30px;
  background: #2d2d2d;
  font-size: 30px;
  color: #fff;
  font-family: "Poppins", sans-serif;
  font-weight: bold;
}
.join-now {
  background: #ec1c25;
  padding: 0px 45px;
  height: 83px;
  line-height: 83px;
  text-transform: uppercase;
  color: #fff;
  display: inline-block;
  font-size: 30px;
  font-weight: 900;
  font-family: "Montserrat", sans-serif;
  text-decoration: none;
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.52);
  z-index: 2;
  transition: all ease-in-out 0.3s;
}

.join-now:hover {
  border-radius: 5px;
  -webkit-box-shadow: 5px 5px 6px 0px rgba(0, 0, 0, 0.67);
  box-shadow: 5px 5px 6px 0px rgba(0, 0, 0, 0.67);
}

@media only screen and (max-width: 768px) {
  .earn-now {
    position: relative;
    padding: 15px 20px;
    font-size: 22px;
  }
  .join-now {
    padding: 0px 25px;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    margin-top: 15px;
  }
  .icon-triggers li {
    width: 40px;
    height: 40px;
    padding: 5px;
  }
  h2 {
    font-size: 16px;
  }
  h3 {
    font-size: 14px;
  }
}
@media only screen and (max-width: 550px) {
  .icon-triggers {
    padding: 0;
  }
  .icon-triggers li {
    width: 100%;
    margin: 0;
    padding: 0;
    line-height: 40px;
  }
}
</style>

<script>
import RechargeDetails from "./RechargeDetails.ts";
export default RechargeDetails;
</script>